// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconWineGlass = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M8.18 1.196l-.617 3.087q-.073.363-.14.717h9.155l-.141-.717-.618-3.087 1.962-.392.623 3.116c.19.946.404 2.022.442 3.088.04 1.09-.103 2.241-.686 3.319A7 7 0 0113 13.929v7.07h2v2H9v-2h2v-7.07a7 7 0 01-5.16-3.602c-.583-1.078-.725-2.23-.686-3.319.038-1.066.253-2.142.442-3.089L6.22.804zM7.154 7.079L7.156 7h9.688l.004.08c.03.873-.09 1.635-.447 2.295a5 5 0 01-4.4 2.625 5 5 0 01-4.402-2.625c-.357-.66-.477-1.422-.446-2.296"
    />
  );
export default SvgIconWineGlass;
